import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class staticPagesEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="form-header">
                <h3 class="form-title">Static Page</h3>
                <h3 class="form-title" data-bind="text: name"></h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>

            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <label for="name" class="form-label">Name</label>
                        <input id="name" data-bind="value: name, event: { focusout: onFocusOutStaticPageName }" type="text" class="input-text">
                    </div>


                    <!-- ko if: editionMode -->
                    <div class="form-group">
                        <label for="permalink" class="form-label">Permalink</label>
                        <div class="row link">
                            <input id="permalink" data-bind="value: permalink" type="text" class="input-text">
                            <a class="btn light icon border only-icon i-link" data-bind="event: { click: viewOnWebsite }"></a>
                        </div>

                    </div>
                    <!-- /ko -->

                    <!-- ko ifnot: editionMode -->
                    <div class="form-group">
                        <label for="permalink" class="form-label">Permalink</label>
                        <div class="row link">
                            <input id="permalink" data-bind="value: permalink" type="text" class="input-text">
                            <a class="btn light icon border only-icon i-link" data-bind="event: { click: viewOnWebsite }"></a>
                        </div>
                    </div>
                    <!-- /ko -->

                    <div class="form-group">
                        <label for="description" class="form-label">Description</label>
                        <input id="description" data-bind="value: description" type="text" class="input-text">
                    </div>
                    <div class="form-group">
                        <label for="category" class="form-label">Category</label>
                        <input id="category" data-bind="value: category" type="text" class="input-text">
                    </div>
                    <div class="form-group">
                        <input type="checkbox" data-bind="checked: indexed" id="indexed">
                        <label class="icon i-check" for="indexed">Indexed</label>
                        
                        <input type="checkbox" data-bind="checked: hasNewsletterSignup" id="hasNewsletterSignup">
                        <label class="icon i-check" for="hasNewsletterSignup">Has Newsletter Signup</label>
                        
                        <input type="checkbox" data-bind="checked: hasSentinelEvents" id="hasSentinelEvents">
                        <label class="icon i-check" for="hasSentinelEvents">Has Sentinel Events</label>
                    </div>
                </div>
                <!-- ko if: versions().length > 0 -->
                <div class="form-body">
                    <strong class="form-sub-title">Version History</strong>
                    <table class="list-action">
                        <thead>
                            <tr>
                                <th><span>Date</span></th>
                                <th><span>User</span></th>
                                <th><span>Actions</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: versions">
                            <tr>
                                <td><span data-bind="text: dateCreated">Date</span></td>
                                <td><span data-bind="text: user.name"><span></td>
                                <td class="align-center">
                                    <button data-bind="event: { click: $parent.downloadVersion }" class="btn only-icon icon i-download" title="download"></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- /ko -->
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group ">
                        <label for="contenttext" class="form-label">Content</label>
                        <textarea id="contenttext" data-bind="value: content" ></textarea>
                    </div>

                </div>
            </div>

            <div class="form-footer">
                <button data-bind="event: { click: onClickCancelEdit }" class="btn " type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
            </div>
            `;
    }

    private viewOnWebsite(value) {

        this.caller.viewOnWebsite(value.permalink());
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "static", "w-form-large"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            name: ko.observable(""),
            permalink: ko.observable(""),
            description: ko.observable(""),
            category: ko.observable(""),
            content: ko.observable(""),
            style: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            contextApp: ko.observable(""),
            indexed: ko.observable(true),
            editionMode: ko.observable(false),
            hasNewsletterSignup: ko.observable(false),
            hasSentinelEvents: ko.observable(false),
            versions: ko.observableArray([]),
            onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();

            },
            onClickSave: function (data, event) {
                self.onClickSave()
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            },
            onFocusOutStaticPageName: (data, event) => {
                self.onFocusOutStaticPageName(event);
            },
            downloadVersion: (version, data, event) => {
                self.downloadVersion(version);
            }
        }
    }


    protected getTemplateName(): string {
        return "staticPagesEdit_template";
    }

    protected onFocusOutStaticPageName(event) {

        if (event.target.value != null && event.target.value != "") {
            this.generatePermalink(event.target.value);
        }

    }

    protected generatePermalink(title){

        let p = this.getTemplateViewModel().permalink();

        if (p == null || p == "") {
            const slug = title.toLowerCase().trim()
                    .replace(/[^\w -]+/g, '')
                    .replace(/[ _]+/g, '-')
                    .replace(/-{2,}/g, '-')
                    .replace(/-$/g, "");
            const isMltBrand = this.caller.getIdBrand() == 50;
            const permalink = '/' + slug + (isMltBrand ? '' : '/');

            this.getTemplateViewModel().permalink(permalink);
        }
    }

    public setId(id){
        this.getTemplateViewModel().id(id)
    }
    public setName(name){
        this.getTemplateViewModel().name(name)
    }
    public setDescription(description){
        this.getTemplateViewModel().description(description)
    }

    public setPermalink(permalink){
        this.getTemplateViewModel().permalink(permalink)
    }
    public setStyle(style){
        this.getTemplateViewModel().style(style)
    }
    public setContentText(content){
        this.getTemplateViewModel().content(content)
    }

    public setDateCreated(dateCreated){
        this.getTemplateViewModel().dateUpdated(dateCreated)
    }

    public setDateUpdated(dateUpdate){
        this.getTemplateViewModel().dateUpdated(dateUpdate)
    }

    public setContextApp(text){
        this.getTemplateViewModel().contextApp(text)
    }

    public setIndexed(indexed) {
        this.getTemplateViewModel().indexed(indexed);
    }

    public isIndexed() {
        this.getTemplateViewModel().indexed();
    }

    public setCategory(category){
        this.getTemplateViewModel().category(category)
    }

    public isEditionMode(value){
        this.getTemplateViewModel().editionMode(value)
    }

    public setHasNewsletterSignup(hasNewsletterSignup) {
        this.getTemplateViewModel().hasNewsletterSignup(hasNewsletterSignup);
    }

    public hasNewsletterSignup() {
        return this.getTemplateViewModel().hasNewsletterSignup();
    }

    public setHasSentinelEvents(hasSentinelEvents) {
        this.getTemplateViewModel().hasSentinelEvents(hasSentinelEvents);
    }

    public getHasSentinelEvents() {
        return this.getTemplateViewModel().hasSentinelEvents();
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }

    public setVersions(versions) {
        this.getTemplateViewModel().versions(versions);
    }

    protected downloadVersion(version) {
        this.caller.downloadVersion(version);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/staticPagesEdit_template.ts